import React from "react";
import { TouchableOpacity, View, Image, Text } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";

const DetermineStakeView = React.memo(
  ({ item, itemPress, upPress, downPress }: any) => {
    return (
      <TouchableOpacity
        disabled
        style={{
          height: 75,
          width: 75,
          backgroundColor: !item.isSelected
            ? AppColors.black_282828
            : AppColors.black_999999,
          borderRadius: 5,
          padding: 5,
          justifyContent: "space-evenly",
          overflow: "hidden",
        }}
        onPress={itemPress}
      >
        {/* Top Section */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingLeft: 5,
          }}
        >
          <Image
            style={{ height: 23, width: 25, resizeMode: "contain" }}
            source={item.image}
          />
          <TouchableOpacity onPress={upPress}>
            <Image
              style={{ height: 21, width: 21, resizeMode: "contain" }}
              source={AppImages.icUpArrow}
            />
          </TouchableOpacity>
        </View>

        {/* Middle Section */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            paddingLeft: 5,
          }}
        >
          <Text
            style={{
              color: AppColors.white,
              paddingLeft: 7,
              fontSize: 12,
              fontWeight: "700",
            }}
          >
            {item.numberOfSteaks}
          </Text>
          <TouchableOpacity onPress={downPress}>
            <Image
              style={{ height: 21, width: 21, resizeMode: "contain" }}
              source={AppImages.icDownArrow}
            />
          </TouchableOpacity>
        </View>

        {/* Bottom Section */}
        <View>
          <Text
            style={{
              color: AppColors.white,
              fontSize: 12,
              fontWeight: "700",
            }}
          >
            {item.name}
          </Text>
        </View>
      </TouchableOpacity>
    );
  },
  (prevProps, nextProps) => {
    // Custom comparison logic to avoid re-renders
    return (
      prevProps.item === nextProps.item &&
      prevProps.itemPress === nextProps.itemPress &&
      prevProps.upPress === nextProps.upPress &&
      prevProps.downPress === nextProps.downPress
    );
  }
);

export default DetermineStakeView;
